import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { CashAccountSelector } from './reducers/CashAccountReducer';
import { CashTableSelector, setCashStatitics, setTriggerRefreshCashTable } from './reducers/CashTableReducer';
import CashAccountModel from './models/CashAccountModel';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';
import CashApi from './api/CashApi';
import BaseResponse from '../../app/BaseResponse';
import CashStatiticModel from './models/CashStatiticModel';
import Utility from '../../app/utility';
import { setAccountInit, setShowCashDetailModal, setTriggerRefreshCashDetail } from './reducers/CashDetailReducer';

const CashTable: React.FunctionComponent = () => {
    let dispatch = useDispatch();
    const cashModelData = useSelector(CashAccountSelector);
    const cashTableData = useSelector(CashTableSelector);

    useEffect(() => {
        if (cashModelData.cashAccounts.length == 0 || cashTableData.triggerRefreshCashTable > 0) {
            dispatch(showLoading(true));
            CashApi.GetCashStatitics().then((response: BaseResponse<CashStatiticModel[]>) => {
                if (response.success) {
                    dispatch(setCashStatitics(response.data));

                    dispatch(showLoading(false));

                    dispatch(setTriggerRefreshCashTable(0));
                } else {
                    Utility.Alert.Error(response.message);
                    dispatch(showLoading(false));
                }
            }).catch((error) => {
                Utility.Alert.Error(error);
                dispatch(showLoading(false));
            })
        }
    }, [cashTableData.triggerRefreshCashTable]);

    const getForeignAccountCount = () => {
        let count = 0;

        _.each(cashModelData.cashAccounts, (cashAccount) => {
            if (cashAccount.country !== "Vietnam") {
                count++;
            }
        });

        return count;
    }

    const getCountryAccountCount = () => {
        let count = 0;

        _.each(cashModelData.cashAccounts, (cashAccount) => {
            if (cashAccount.country === "Vietnam") {
                count++;
            }
        });

        return count;
    }

    const getForeignAccounts = () => {
        var accounts = _.filter(cashModelData.cashAccounts, (cashAccount) => {
            return cashAccount.country !== "Vietnam";
        });

        return accounts ? accounts : [] as CashAccountModel[];
    }

    const getCountryAccounts = () => {
        var accounts = _.filter(cashModelData.cashAccounts, (cashAccount) => {
            return cashAccount.country === "Vietnam";
        });

        return accounts ? _.sortBy(accounts, (item) => {
            return item.currency;
        }) : [] as CashAccountModel[];
    }

    const getAmount = (account: string) => {
        let cashItem = _.find(cashTableData.cashStatitics, (item) => {
            return item.account == account;
        });
        return cashItem ? cashItem.amount : 0;
    }

    const getForeignTotal = () => {
        let total = 0;

        _.each(cashModelData.cashAccounts, (cashAccount) => {
            if (cashAccount.country !== "Vietnam") {
                total += getAmount(cashAccount.account);
            }
        });

        return total;
    }

    const getCountryTotalUSD = () => {
        let total = 0;

        _.each(cashModelData.cashAccounts, (cashAccount) => {
            if (cashAccount.country === "Vietnam" && cashAccount.currency === "USD") {
                total += getAmount(cashAccount.account);
            }
        });

        return total;
    }

    const getCountryTotalVND = () => {
        let total = 0;

        _.each(cashModelData.cashAccounts, (cashAccount) => {
            if (cashAccount.country === "Vietnam" && cashAccount.currency === "VND") {
                total += getAmount(cashAccount.account);
            }
        });

        return total;
    }

    return <>
        <Table className="datatable cash-table">
            <TableHead>
                <TableRow className="datatable-head">
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell>Account</TableCell>
                    <TableCell>Amount</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell rowSpan={getForeignAccountCount() + 2}>
                        Nước ngoài
                    </TableCell>
                </TableRow>
                {
                    _.map(getForeignAccounts(), (account, index) => {
                        return <TableRow
                            onClick={() => {
                                dispatch(setAccountInit(account.account));
                                dispatch(setShowCashDetailModal(true));
                                dispatch(setTriggerRefreshCashDetail((new Date()).getTime()));
                            }}
                        >
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{account.account}</TableCell>
                            <TableCell>{Utility.NumberFormat.formatUSD(getAmount(account.account))}</TableCell>
                        </TableRow>
                    })
                }
                <TableRow>
                    <TableCell></TableCell>
                    <TableCell><b>Total</b></TableCell>
                    <TableCell><b>{Utility.NumberFormat.formatUSD(getForeignTotal())}</b></TableCell>
                </TableRow>
                <TableRow>
                    <TableCell rowSpan={getCountryAccountCount() + 3}>
                        Việt Nam
                    </TableCell>
                </TableRow>
                {
                    _.map(getCountryAccounts(), (account, index) => {
                        return <TableRow
                            onClick={() => {
                                dispatch(setAccountInit(account.account));
                                dispatch(setShowCashDetailModal(true));
                                dispatch(setTriggerRefreshCashDetail((new Date()).getTime()));
                            }}
                        >
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{account.account}</TableCell>
                            <TableCell>{account.currency === "VND" ? Utility.NumberFormat.formatVND(getAmount(account.account)) : Utility.NumberFormat.formatUSD(getAmount(account.account))}</TableCell>
                        </TableRow>
                    })
                }
                <TableRow>
                    <TableCell></TableCell>
                    <TableCell><b>Total USD</b></TableCell>
                    <TableCell><b>{Utility.NumberFormat.formatUSD(getCountryTotalUSD())}</b></TableCell>
                </TableRow>
                <TableRow>
                    <TableCell></TableCell>
                    <TableCell><b>Total VND</b></TableCell>
                    <TableCell><b>{Utility.NumberFormat.formatVND(getCountryTotalVND())}</b></TableCell>
                </TableRow>
            </TableBody>
        </Table>
    </>
};

export default CashTable;